module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table loginpage"
  }, [_c('div', {
    staticClass: "row vertical-10p logincntrrow"
  }, [_c('div', {
    staticClass: "container logincntr"
  }, [_c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4 loginFormwrp"
  }, [_c('img', {
    staticClass: "center-block logina-logo",
    attrs: {
      "src": "/static/img/d2dvoyager-logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "confirm forcechange"
  }, [_c('h2', [_vm._v("Forget Password")]), _vm._v(" "), _c('div', {
    staticClass: "error loginModuleToperror"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "error "
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-forgetpassword"
  }, [_c('div', {
    staticClass: "input-group",
    class: _vm.errors.has('username') ? 'error' : ''
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        email: true
      }),
      expression: "{ email: true }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "User Name",
      "name": "username",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": _vm.validemail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group forgetsubmit"
  }, [_c('span', [_vm._v("If you are facing a issue, contact support on Yammer Group")]), _vm._v(" "), _c('button', {
    class: 'loginsubmit btn btn-primary btn-lg',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("GO")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f26899a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ForgotPassword.vue
// module id = 1014
// module chunks = 1